import '@fortawesome/fontawesome-free/css/all.min.css';
import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Button, Input } from "reactstrap";
import { BiPlus, BiTrash } from "react-icons/bi";
import "./UploadEvidence.css";

// Styled Components
const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
  width: 500px;
  height: 100vh;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  padding: 20px;
  z-index: 2000;
  overflow-y: auto;
`;

const FileTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
`;

const TableHeader = styled.th`
  text-align: left;
  color: #5C5C5C;
  font-size: 12px;
  font-weight: 400;
  padding: 8px;
  border-bottom: 1px solid #ddd;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
`;

const TableData = styled.td`
  padding: 8px;
`;

function Sidebar({
  isOpen,
  onClose,
  evidenceData = [],
  onAddFile,
  onFileRemove,
  formType,
  updateForbidden
}) {
  const [nameInput, setNameInput] = useState("");
  const [fileInput, setFileInput] = useState();
  const [errors, setErrors] = useState({
    name: "",
    file: ""
  });

  //add error

  // Clear inputs whenever the sidebar opens for a new question
  useEffect(() => {
    if (isOpen) {
      setNameInput("");
      setFileInput();
      setErrors({ name: "", file: "" });
      if (document.getElementById('fileInput')) {
        document.getElementById('fileInput').value = '';
      }
    }
  }, [isOpen]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const oversizedFile = selectedFile.size > 10 * 1024 * 1024;
      if (oversizedFile) {
        setErrors({
          ...errors,
          file: 'File must be under 10MB'
        });
        return;
      }
      setFileInput(selectedFile);
      setErrors({
        ...errors,
        file: ""
      });
    }
  };

  const onAdd = () => {
    if(nameInput && fileInput){
      document.getElementById('fileInput').value = '';
      onAddFile({
        file: fileInput,
        name: nameInput
      })
      setFileInput();
      setNameInput('');
    }else{
      if(!nameInput){
        setErrors({
          ...errors,
          name: "Please enter name."
        })
      }
      if(!fileInput){
        setErrors({
          ...errors,
          file: "Please upload file."
        })
      } 
    }
  }

  return (
    <SidebarContainer isOpen={isOpen}>
      <div className="flex justify-between text-xl my-3 font-medium">
        <h3>Add Evidence</h3>
        <i className="fas fa-times-circle cursor-pointer" onClick={onClose}/>
      </div>
      <div className='flex flex-col justify-between'>
        <div>
          {/* Dynamic Label based on formType */}
          <div className='flex space-x-3 my-3 items-center'>
            <p className='text-green-700'>
              {(formType === "landscaping" || formType === "benchmarking") ? "Policy Name" : "Name"}
              <span className="required">*</span>
            </p>
            <Input
              type="text"
              value={nameInput}
              disabled={updateForbidden}
              onChange={(e) => setNameInput(e.target.value)}
              placeholder={`Enter ${(formType === "landscaping" || formType === "benchmarking") ? "policy name" : "name"}`}
            />
          </div>

          {/* Upload Files section */}
          <div className='flex space-x-3 my-3 items-center'>
            <p className='text-green-700'>Upload File<span className="required">*</span></p>
            <input
              type="file"
              id="fileInput"
              onChange={handleFileChange}
              disabled={updateForbidden}
            />
          </div>
          <div className='flex my-3 justify-end'>
            <Button className='common-button' onClick={onAdd} disabled={updateForbidden}>
              <BiPlus/> Add file
            </Button>
          </div>
        </div>
        <div>
          {/* Dynamic Table Headers based on formType */}
          {(evidenceData?.length > 0) &&
            <FileTable>
              <thead>
                <tr>
                  <TableHeader>
                    {(formType === "landscaping" || formType === "benchmarking") ? "Policy Name" : "Name"}
                  </TableHeader>
                  <TableHeader></TableHeader>
                </tr>
              </thead>
              <tbody>
                {evidenceData.map((file, index) => (
                  <TableRow key={index}>
                    <TableData>{file.name}</TableData>
                    <TableData>
                      <div className="flex justify-end gap-2">
                        {/* <Button
                          variant="outline"
                          size="sm"
                          onClick={() => downloadExistingFile(file.name)}
                          disabled={disabled}
                          className="flex items-center gap-1"
                        >
                          Download
                        </Button> */}
                        <Button
                          size="sm"
                          onClick={() => onFileRemove(index)}
                          // disabled={disabled}
                          className="common-outlined-button text-red-500 border-red-500"
                        >
                          <BiTrash className="w-4 h-4" />
                        </Button>
                      </div>
                    </TableData>
                  </TableRow>
                ))}
              </tbody>
            </FileTable>}
        </div>
      </div>
    </SidebarContainer>
  );
}

export default Sidebar;